module.exports = __webpack_public_path__ + "static/media/AntlerlessDeer.svg";